    <div class="flex flex-row w-100 pt-3" *ngIf="!reviewEmployee">
        <div class="col-6 p-0">
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="handleChangeTabMenu($event)">
                <mat-tab label="Store Employees"></mat-tab>
                <mat-tab label="Web Admins"></mat-tab>
            </mat-tab-group>
            <span class="ml-3 mt-2">
                <mat-menu #menu="matMenu">
                    <button (click)="handleShowCreateEmployee(menuTab.StoreEmployees)" mat-menu-item>Store Employee</button>
                    <button (click)="handleShowCreateEmployee(menuTab.WebAdmins)" mat-menu-item>Web Admins</button>
                </mat-menu>
            </span>
        </div>
        <div class="col-6 p-0 text-end">
            <mat-form-field class="mr-2 custom-search-field">
                <mat-label>Search</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput [(ngModel)]="filter.searchTerm" (keyup)="applyFilter()" placeholder="Search by name or email" #input>
            </mat-form-field> 
            <button mat-button class="create-employee-button" (click)="handleShowCreateEmployee(activeTab)">
                <mat-icon>add_circle</mat-icon> Add Employee
            </button>
        </div>
    </div>

    <div class="backdrop"*ngIf="loading">
        <mat-spinner mode="indeterminate" diameter="56" strokeWidth="4"></mat-spinner>
    </div>

    <div class="mat-elevation-z8" *ngIf="merchantUsers.length > 0">
        <table *ngIf="!loading" mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)">
            <ng-container matColumnDef="UserId">
                <th th mat-header-cell *matHeaderCellDef mat-sort-header> Employee ID </th>
                <td mat-cell *matCellDef="let element"> {{element.UserId}} </td>
            </ng-container>
            <ng-container matColumnDef="CreatedAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created </th>
                <td mat-cell *matCellDef="let element"> {{element.CreatedAt}} </td>
            </ng-container>
            <ng-container matColumnDef="UserName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.UserName}} </td>
            </ng-container>
            <ng-container matColumnDef="RoleName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
                <td mat-cell *matCellDef="let element"> {{element.RoleName}} </td>
            </ng-container>
            <ng-container matColumnDef="Location">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-4"> Locations</th>
                <td mat-cell *matCellDef="let element" class="col-4"> 
                    <p class="m-0" *ngFor="let store of element.Stores">
                        <b>{{store.Name}}</b> - {{store.Address}}
                    </p>
                </td>
            </ng-container>
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element">
                    <span class="action-icon-svg" (click)="handlePopupLinkClick(element, false)">
                        <img src="../Content/xpress-app/images/svg/icon_view.svg" />
                    </span>
                    <span class="action-icon-svg" *ngIf="!reviewEmployee"
                        (click)="handlePopupLinkClick(element, true)">
                        <img src="../Content/xpress-app/images/svg/icon_edit.svg" />
                    </span>
                    <span class="action-icon-svg" (click)="deleteMerchantUser(element.UserId)">
                        <img src="../Content/xpress-app/images/svg/icon_suspend.svg" />
                    </span>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    
        <mat-paginator class="mat-paginator-sticky"
                        [length]="totalRecords"
                        [pageSize]="rowsPerPage"
                        [pageSizeOptions]="rowsPerPageOptions"
                        showFirstLastButtons
                        aria-label="Select page of periodic elements"
                        (page)="onNextPage($event)">
        </mat-paginator>
    </div>

    <div class="flex-row w-full" *ngIf="merchantUsers.length < 1">
        <div class="col-12 text-center align-content-center h-30rem">
            <img src="/XpressApp/assets/images/partner/onboarding/no_employees.png" class="mb-2" />
            <div class="employee-not-title mb-1">No Employees Yet</div>
            <div class="employee-not-description mb-3">You will able to see all your assigned drivers here</div>
        </div>
    </div>
    <p-toast></p-toast>
